"use client"

import { useGameFavorite } from "@/features/casino/hooks/useGameFavorite"
import { gameCardTexts } from "@/features/casino/localization/texts"
import { cn } from "@/lib/utils"
import { HeartIcon } from "@/src/shared/assets/icons"

type GameFavoriteButtonProps = {
  gameCode: string
  className?: string
}

export function GameFavoriteButton({
  gameCode,
  className
}: GameFavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useGameFavorite()
  const favorite = isFavorite(gameCode)

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation()
        void toggleFavorite(gameCode)
      }}
      aria-label={
        favorite ? gameCardTexts.removeFavorite : gameCardTexts.addFavorite
      }
      className={cn(
        "cursor-pointer",
        favorite ? "text-danger-400" : "text-white/60 hover:text-white",
        className
      )}
    >
      <HeartIcon className="size-6" aria-hidden />
    </button>
  )
}
